<div class="insurance-claim-page">
    <!-- GARAGE DETAILS HEADER (ONLY THIS PAGE) -->
    <nav class="navbar navbar-expand-lg classic transparent navbar-light"  [class.navbar-white]="isNavbarWhite">
        <div class="container flex-lg-row flex-nowrap align-items-center nav-bar">
            <div
            class="navbar-collapse-wrapper d-flex flex-row flex-nowrap w-100 justify-content-between align-items-center padding" >
            <div class="logo-wth-txt d-flex align-items-center gap-3 nav-logo  clickable"  (click)="goToGarageDetails()">
                <img
                    [src]="garageData?.primaryLogo || 'assets/img/mobile_autoverse_logo.svg'"
                    alt="Garage Logo"
                    class="garage-nav-logo"  />
            </div>

            <div class="d-lg-none me-2 qck-bkng" *ngIf="showQuickBooking">
                <button
                    class="btn btn-sm btn-outline-primary rounded-pill qck-bkng-btn"
                    (click)="openRequestModal()">
                    Quick Booking
                </button>
            </div>
            <button
                class="navbar-toggler d-lg-none mat-hamburger-btn"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target=".offcanvas-nav"
                aria-label="Toggle navigation"
            >
                <mat-icon>menu</mat-icon>
            </button>

            </div>

            <div #offcanvasNav class="navbar-collapse offcanvas offcanvas-nav offcanvas-start">
            <div class="offcanvas-header d-lg-none">
                <h3 class="text-white fs-30 mb-0"> {{ garageData?.garageShortName }}</h3>
                <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="offcanvas"
                ></button>
            </div>

            <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
                <ul class="navbar-nav align-items-center-abt">
                <!-- <a class="nav-link" (click)="scrollTo('hero')">Hero</a>
                <a class="nav-link" (click)="scrollTo('benefits')">Benefits</a>
                <a class="nav-link" (click)="scrollTo('process')">Process</a>
                <a class="nav-link" (click)="scrollTo('insurance-partners')">Partners</a> -->
                <!-- <a class="nav-link" [routerLink]="['/garage-details', key]" fragment="our-services">Our Services</a> -->
                <a class="nav-link" (click)="goToServices()">Our Services</a>
                <li class="nav-item book" *ngIf="showRequestBtn">
                    <button
                    class="btn btn-lg btn-outline-white rounded-pill rqstbtn"
                    data-bs-toggle="modal" data-bs-target="#requestCallBackModal">
                    Book an Appointment
                    </button>
                </li>
                </ul>

            </div>
            </div>
        </div>
    </nav>

    <section #heroSection class="wrapper bg-light hero-wrapper" id="hero">
    <div class="container">
        <div class="card bg-soft-primary rounded-4 mt-2 mb-13 mb-md-17">
        <div class="card-body p-md-10 py-xl-11 px-xl-15">
            <div class="row gx-lg-8 gx-xl-0 gy-10 align-items-center">
            <div class="col-lg-6 order-lg-2 d-flex position-relative">
                <img class="img-fluid ms-auto mx-auto me-lg-8" src="./assets/img/photos/co3.png" srcset="./assets/img/photos/co3@2x.png 2x" alt="" data-cue="fadeIn">
                <div data-cue="slideInRight" data-delay="300">
                <div class="card shadow-lg position-absolute" style="bottom: 10%; right: -3%;">
                    <div class="card-body py-4 px-5">
                    <div class="d-flex flex-row align-items-center">
                        <div>
                        <div class="icon btn btn-circle btn-md btn-soft-primary pe-none mx-auto me-3"> <i class="uil uil-users-alt"></i> </div>
                        </div>
                        <div>
                        <h3 class="counter mb-0 text-nowrap"> 500+</h3>
                        <p class="fs-14 lh-sm mb-0 text-nowrap">Claim Processed</p>
                        </div>
                    </div>
                    </div>
                    <!--/.card-body -->
                </div>
                <!--/.card -->
                </div>
                <!--/div -->
            </div>
            <!--/column -->
            <div class="col-lg-6 text-center text-lg-start"  data-group="page-title" >
                <h1 class="display-2 mb-5">Cashless Insurance Claims Made Simple</h1>
                <p class="lead fs-lg lh-sm mb-7 pe-xl-10">Cashless repairs at our multi-brand garage. We work with all major insurance companies.</p>
                <div class="d-flex justify-content-center justify-content-lg-start"  data-group="page-title-buttons">
                <span><a href="#" class="btn btn-lg btn-primary rounded-pill me-2">Get Claim Assistance</a></span>
                <span><a href="#" class="btn btn-lg btn-outline-primary rounded-pill"> Renew Insurance</a></span>
                </div>
            </div>
            <!--/column -->
            </div>
            <!--/.row -->
        </div>
        <!--/.card-body -->
        </div>
        <!--/.card -->
    </div>
    <!-- /.container -->
    </section>
    <!-- /section -->

    <section class="wrapper bg-light" id="benefits">
    <div class="container py-10">
        <div class="row">
        <div class="col-lg-8 col-xl-7 col-xxl-6">
            <h2 class="fs-15 text-uppercase text-muted mb-3">Cashless Insurance Claims</h2>
            <h3 class="display-4 mb-9">No upfront payment. No confusion. We coordinate directly with your insurance company.</h3>
        </div>
        <!-- /column -->
        </div>
        <!-- /.row -->
        <div class="row gx-md-8 gy-8">
        <div class="col-md-6 col-lg-3">
            <div class="icon btn btn-block btn-lg btn-soft-yellow pe-none mb-5"> <i class="uil uil-phone-volume"></i> </div>
            <h4>No Upfront Payment</h4>
            <p class="mb-3">Get your vehicle repaired without paying anything upfront. We handle all billing directly with your insurance company.</p>
            <!-- <a href="#" class="more hover link-yellow">Learn More</a> -->
        </div>
        <!--/column -->
        <div class="col-md-6 col-lg-3">
            <div class="icon btn btn-block btn-lg btn-soft-red pe-none mb-5"> <i class="uil uil-shield-exclamation"></i> </div>
            <h4>Faster Approvals</h4>
            <p class="mb-3">Our experienced team ensures quick documentation and faster claim approvals from insurance companies.</p>
            <!-- <a href="#" class="more hover link-red">Learn More</a> -->
        </div>
        <!--/column -->
        <div class="col-md-6 col-lg-3">
            <div class="icon btn btn-block btn-lg btn-soft-leaf pe-none mb-5"> <i class="uil uil-laptop-cloud"></i> </div>
            <h4>Direct Insurance Billing</h4>
            <p class="mb-3">We coordinate directly with your insurance provider, handling billing and settlement on your behalf.</p>
            <!-- <a href="#" class="more hover link-leaf">Learn More</a> -->
        </div>
        <!--/column -->
        <div class="col-md-6 col-lg-3">
            <div class="icon btn btn-block btn-lg btn-soft-blue pe-none mb-5"> <i class="uil uil-chart-line"></i> </div>
            <h4>Quality Repairs</h4>
            <p class="mb-3">Repairs are carried out by certified technicians using genuine parts to ensure long-lasting quality and reliability.</p>
            <!-- <a href="#" class="more hover link-blue">Learn More</a> -->
        </div>
        <!--/column -->
        </div>
        <!--/.row -->
    </div>
    <!-- /.container -->
    </section>
    <!-- /section -->
    <section class="wrapper bg-light" id="process">
    <div class="container py-10">
        <h2 class="display-4 mb-3"> Insurance Claim Process</h2>
        <p class="lead fs-lg mb-8">We manage <span class="underline"> the entire process</span> for you.</p>
        <div class="row gx-lg-8 gx-xl-12 gy-6 process-wrapper line">
        <div class="col-md-6 col-lg-3" style="width: 20%;"> <span class="icon btn btn-circle btn-lg btn-soft-primary pe-none mb-4"><span class="number">01</span></span>
            <h4 class="mb-1">Vehicle Inspection</h4>
            <p class="mb-0">Our experienced team carefully assesses all visible and hidden damage to ensure nothing is missed.</p>
        </div>
        <!--/column -->
        <div class="col-md-6 col-lg-3" style="width: 20%;"> <span class="icon btn btn-circle btn-lg btn-primary pe-none mb-4"><span class="number">02</span></span>
            <h4 class="mb-1">Claim Registration</h4>
            <p class="mb-0">We file and submit all required documentation on your behalf, ensuring a smooth and timely claim process.</p>
        </div>
        <!--/column -->
        <div class="col-md-6 col-lg-3" style="width: 20%;"> <span class="icon btn btn-circle btn-lg btn-soft-primary pe-none mb-4"><span class="number">03</span></span>
            <h4 class="mb-1">Insurance Approval</h4>
            <p class="mb-0">We work closely with your insurance company to help fast-track approval and reduce unnecessary waiting time.</p>
        </div>
        <!--/column -->
        <div class="col-md-6 col-lg-3" style="width: 20%;"> <span class="icon btn btn-circle btn-lg btn-soft-primary pe-none mb-4"><span class="number">04</span></span>
            <h4 class="mb-1">Repair & Settlement</h4>
            <p class="mb-0">Quality repairs with direct billing
            We deliver quality repairs and bill your insurance company directly to give you a smooth and hassle-free experience.</p>
        </div>
        <!--/column -->
        <!--/column -->
        <div class="col-md-6 col-lg-3" style="width: 20%;"> <span class="icon btn btn-circle btn-lg btn-soft-primary pe-none mb-4"><span class="number">05</span></span>
            <h4 class="mb-1">Vehicle Delivery</h4>
            <p class="mb-0">Your vehicle is returned in perfect condition after thorough repairs and final quality checks for complete peace of mind.</p>
        </div>
        <!--/column -->
        </div>
        <!--/.row -->
    </div>
    <!-- /.container -->
    </section>
    <!-- /section -->
    <section class="wrapper bg-light insurance-section" *ngIf="garageData?.insuranceUrls?.length" id="insurance-partners">
    <div class="container py-10 text-center">
        <h2 class="display-5 mb-3">Insurance Partners</h2>
        <p class="lead mb-8">We support cashless claims with all major insurance providers</p>

        <div class="swiper insurance-swiper">
        <div class="swiper-wrapper">
            <div class="swiper-slide" *ngFor="let logo of garageData.insuranceUrls">
            <div class="insurance-logo-card">
                <img [src]="logo" alt="Insurance Logo" />
            </div>
            </div>
        </div>

        <!-- Arrows -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
        </div>
    </div>
    </section>
    <!-- ==========requesta-a-call-bac-pop-up======= -->
    <div class="modal fade" id="requestCallBackModal" tabindex="-1" aria-labelledby="requestCallBackModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg custom-modal">
        <div class="modal-content" style="border-radius: 8px; padding: 10px;"> 
            <div class="modal-content-sub" >
            <!-- Header -->
                <div class="d-flex justify-content-between align-items-center mb-3" style=" padding: 10px 20px; margin: 0 !important; background: linear-gradient(to right, #F7FBFF, #FFFFFF); border-radius: 10px;">
                    <h3 class="fw-bold m-0" style="font-size: 20px; font-weight: 900 !important; color: #0B2636;">
                    <div class="call-icon-and-text">
                        <mat-icon>bookmark_border</mat-icon>
                        <div>Book an Appointment</div>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    </h3>
                </div>

                <p class="text-muted mb-4" style=" font-size: 14px !important;color: #57738A !important; padding: 5px 20px; margin: 10px 0px !important; font-weight: 400;">
                    Quick and easy appointment booking.
                </p>

                <!-- Form -->
                <form [formGroup]="callbackForm" (ngSubmit)="submitForm()" class="callback-form">

                    <div class="form-scroll-area">

                        <!-- Name -->
                        <div class="form-floating mb-3">
                        <input type="text" formControlName="name" class="form-control" id="custName" placeholder="Name">
                        <label for="custName">Name *</label>
                        </div>
                        <div class="text-danger small mb-2"
                            *ngIf="submitted && callbackForm.get('name')?.invalid">
                        Name is required
                        </div>

                        <!-- Mobile -->
                        <div class="form-floating mb-3">
                        <input type="text" formControlName="mobile" class="form-control" id="custMobile" placeholder="Mobile Number" maxlength="10">
                        <label for="custMobile">Mobile Number *</label>
                        </div>
                        <div class="text-danger small mb-2"
                            *ngIf="submitted && callbackForm.get('mobile')?.invalid">
                        <span *ngIf="callbackForm.get('mobile')?.errors?.['required']">Mobile number is required</span>
                        <span *ngIf="callbackForm.get('mobile')?.errors?.['pattern']">Mobile number must be 10 digits</span>
                        </div>

                        <!-- Registration Number -->
                        <div class="form-floating mb-3">
                        <input type="text" formControlName="registrationNumber" (input)="formatRegistrationNumber()" class="form-control" id="regNo" placeholder="KA 03 MX 5059">
                        <label for="regNo">Registration Number *</label>
                        </div>
                        <div class="text-danger small mb-2"
                            *ngIf="submitted && callbackForm.get('registrationNumber')?.invalid">
                        <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['required']">Registration number is required</span>
                        <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['pattern']">Format must be like KA 03 MX 4048</span>
                        </div>

                        <!-- Email -->
                        <div class="form-floating mb-3">
                        <input type="email" formControlName="email" class="form-control" id="custEmail" placeholder="Email">
                        <label for="custEmail">Email (Optional)</label>
                        </div>
                    </div>

                    <!-- Sticky Button -->
                    <div class="form-footer">
                        <button type="submit" class="btn btn-primary w-100 submit-btn">
                        Submit Details
                        </button>
                    </div>

                </form>
            </div>

        </div>
    </div>
    </div>

    <!-- Success Confirmation Modal -->
    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="width: 30%;">
        <div class="modal-content text-center">
            <div class="modal-body">
            <p style="margin-bottom: 0;">{{ successMessage }}</p>
            <p style="color: green; font-size: 100px;"><i class="uil uil-check-circle"></i></p>
            <p class="lead mb-6">We will call you shortly</p>
            <button type="button" class="btn btn-secondary rounded-pill btn-login w-100 mb-2" (click)="closeSuccessModal()" style="background: #144579;">OK</button>
            </div>
        </div>
        </div>
    </div>
    <!-- <div class="btn-group">
        <button class="btn primary"  data-bs-toggle="modal" data-bs-target="#requestCallBackModal" style="font-size: 16px;">
            <mat-icon>bookmark_border</mat-icon>
            Book a Service
        </button>
    </div> -->
</div>

<section class="wrapper gradient-8 bg-lines" id="contact-us">
  <div class="container py-15 py-md-17 text-center">
    <div class="row">
      <div class="col-lg-10 col-xl-9 col-xxl-8 mx-auto text-center">
        <h2 class="fs-16 text-uppercase text-white mb-3">TRUSTED BY CAR OWNERS</h2>
        <h3 class="display-3 text-white mb-6">We are
        <span class="underline-2 underline-gradient-6"><em>trusted</em></span> by over 5,000+ car owners.Book your appointment with confidence.</h3>
        <!-- <a href="#" class="btn btn-white">Join Us</a> -->
        <div class="button_div">
          <button class="requestBtn-new" data-bs-toggle="modal" data-bs-target="#requestCallBackModal">
            Book an Appointment
          </button>
        </div>
      </div>
      <!-- /column -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container -->
</section>
<!-- /section -->

<footer class="bg-dark text-inverse">
  <div class="container py-10">
    <div class="row gy-6 gy-lg-0">
      <div class="col-md-4 col-lg-3">
        <div class="widget">
          <div  class="bottom-logo-txt">
            <!-- <img style="align-items: center;  display: flex; justify-content: center;  width: 24px;" class="mb-4 imp" src="../../../assets/img/mobile_autoverse_logo.svg" srcset="./assets/img/mobile_autoverse_logo.svg 2x" alt="" />
            <div class="bottom-logo-txt-main" >AUTOVERSE</div> -->
            <img
                    [src]="garageData?.primaryLogo || 'assets/img/mobile_autoverse_logo.svg'"
                    alt="Garage Logo"
                    class="navbar-garage-logo"  />
          </div>
          <p class="mb-4 p" style="font-size: 16px">© 2023 Autoverse.  <br class="d-none d-lg-block" />All rights reserved.</p>
          <!-- <nav class="nav social social-white">
            <a href="#"><i class="uil uil-twitter"></i></a>
            <a href="#"><i class="uil uil-facebook-f"></i></a>
            <a href="#"><i class="uil uil-dribbble"></i></a>
            <a href="#"><i class="uil uil-instagram"></i></a>
            <a href="#"><i class="uil uil-youtube"></i></a>
          </nav> -->
          <!-- /.social -->
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
      <div class="col-md-4 col-lg-3">
        <div class="widget">
          <h4 class="widget-title text-white mb-3">Get in Touch</h4>
          <address class="pe-xl-15 pe-xxl-17 address">{{ garageData?.address }}</address>
          <a href="mailto:#">{{ garageData.email }}</a><br />
          <div style="color: #aaa !important;    font-weight: 500;">{{ garageData.mobileNumber }}</div>
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
      <div class="col-md-4 col-lg-3">
        <div class="widget">
          <h4 class="widget-title text-white mb-3 footre-learnmore">Learn More</h4>
          <ul class="list-unstyled  mb-0">
            <li><a href="#">Book Service Appointment</a></li>
            <li><a class="nav-link" (click)="scrollTo('About-us')">About Us</a></li>
            <li><a class="nav-link" (click)="scrollTo('our-services')">Our Services</a></li>
            <li><a class="nav-link" (click)="scrollTo('customer-review')">Customer Reviews</a></li>
            <li><a class="nav-link" (click)="scrollTo('contact-us')">Contact Us</a></li>
          </ul>
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
      <div class="col-md-12 col-lg-3">
        <div class="widget">
          <h4 class="widget-title text-white mb-3">Service With Care</h4>
          <p class="mb-5">A friendly garage that understands your car and your concerns.</p>
          <div class="newsletter-wrapper">
            <!-- Begin Mailchimp Signup Form -->
            <div id="mc_embed_signup2">
              <form action="https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&amp;id=b49ef47a9a" method="post" id="mc-embedded-subscribe-form2" name="mc-embedded-subscribe-form" class="validate dark-fields" target="_blank" novalidate>
                <div id="mc_embed_signup_scroll2">
                  <div class="mc-field-group input-group form-floating">
                    <!-- <input type="email" value="" name="EMAIL" class="required email form-control" placeholder="Email Address" id="mce-EMAIL2">
                    <label for="mce-EMAIL2">Email Address</label>
                    <input type="submit" value="Join" name="subscribe" id="mc-embedded-subscribe2" class="btn btn-primary"> -->
                    <div class="button_div">
                      <button class="requestBtn-new" data-bs-toggle="modal" data-bs-target="#requestCallBackModal">
                        Book an Appointment
                      </button>
                    </div>
                  </div>
                  <div id="mce-responses2" class="clear">
                    <div class="response" id="mce-error-response2" style="display:none"></div>
                    <div class="response" id="mce-success-response2" style="display:none"></div>
                  </div> <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_ddc180777a163e0f9f66ee014_4b1bcfa0bc" tabindex="-1" value=""></div>
                  <div class="clear"></div>
                </div>
              </form>
            </div>
            <!--End mc_embed_signup-->
          </div>
          <!-- /.newsletter-wrapper -->
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
    </div>
    <!--/.row -->
  </div>
  <!-- /.container -->
</footer>
<div class="page-loader" *ngIf="isPageLoading">
  <div class="spinner"></div>
</div>
